"use client";

import { CommandGroup, CommandItem } from "@/components/ui/command";
import { useTranslations } from "next-intl";
import { Loader2Icon, LocateFixedIcon } from "lucide-react";
import type { UseMyLocationButtonProps } from "./types";

export function UseMyLocationButton({
  isLoading,
  error,
  onSelect,
}: UseMyLocationButtonProps) {
  const t = useTranslations();

  return (
    <CommandGroup>
      <CommandItem
        onSelect={onSelect}
        className="flex items-center gap-3 w-full px-2 py-4 bg-transparent hover:bg-accent hover:text-accent-foreground data-[selected=true]:bg-accent data-[selected=true]:text-accent-foreground cursor-pointer"
        disabled={isLoading}
      >
        {isLoading ? (
          <Loader2Icon
            data-testid="loading-spinner"
            className="size-5 text-foreground animate-spin shrink-0"
            aria-label={t("locationSelector.locating")}
          />
        ) : (
          <LocateFixedIcon className="size-5 text-foreground shrink-0" />
        )}
        <span className="text-base font-medium text-secondary-foreground">
          {t("locationSelector.useMyLocation")}
        </span>
      </CommandItem>
      {error && (
        <div role="alert" className="px-3 py-2 text-sm text-destructive">
          {error.code === "PERMISSION_DENIED"
            ? t("locationSelector.geolocationDenied")
            : t("locationSelector.geolocationError")}
        </div>
      )}
    </CommandGroup>
  );
}
